<div>
	<div class="ibox-title">
		<h5>{{ Option?.Desc }}</h5>
	</div>

	<div class="ibox-content">
		<div class="SelectGraphGrid">
			<label>Select Graph:</label>
			<select [disabled]="IsLoading() == true" class="form-control" name="Option" [(ngModel)]="Option" (ngModelChange)="onOptionChange($event)">
				<option value="" style="display: none"></option>
				<option *ngFor="let o of lstOption" [ngValue]="o">
					{{ o.Desc }}
				</option>
			</select>
		</div>

		<div>
			<p-chart *ngIf="ShowGraph == true" type="line" [data]="basicData" [options]="basicOptions"></p-chart>
		</div>
	</div>
</div>
